import {convertedContactsThreshold} from '@/pages/responses/utils/constant'
import {getConvertedContacts} from '@/api/responses'
import {IConvertedContact, IReturningContactsCard, IReturningContactsCardTypes} from '@/entities'

// WEB-8116 centralize this function
export async function convertedContacts(): Promise<IReturningContactsCard[]> {
    return getConvertedContacts().then(function ($r){
        const data = $r.data
        const returningContactCards : Array<IReturningContactsCard> = []

        data.forEach(contact =>{
            const card: IReturningContactsCard = {
                metrics: contact.metrics,
                type: contact.type === 'PD' ? IReturningContactsCardTypes.convertedDetractors : IReturningContactsCardTypes.convertedPromoters,
                description: contact.description,
                total: contact.total,
                underThreshold: checkThreshold(contact),
                first: contact.locations?.[0],
                second: contact.locations?.[1],
                third: contact.locations?.[2],
            }

            returningContactCards.push(card)
        })

       return returningContactCards
    })
}

function checkThreshold(contact: IConvertedContact): boolean {
    let noValidLocation = true

    contact.locations?.forEach(contactFromLocation => {
        noValidLocation = !(!noValidLocation || contactFromLocation.topic)
    })

    return contact.total < convertedContactsThreshold.number ||    // total responses less than threshold number
            noValidLocation                                        // no location has "threshold" number of responses
}
